import FolderService from "./folders.service";
export default class DrawerService extends FolderService {
  namespace = "folder";
  icon = "BlueCabinet";
  name = "Drawer";
  favicon = "Cabinet";
  Width = 690;
  action = "action";
  DOMAIN = -1;
  constructor() {
    super("folders");
  }
}
